import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface RequiredChoiceBadgeProps {
  isRequired: boolean;
  hasSelection: boolean;
  text?: string;
}

const RequiredChoiceBadge: React.FC<RequiredChoiceBadgeProps> = ({
  isRequired,
  hasSelection,
}) => {
  const { t } = useTranslation();
  if (!isRequired) return null;

  const badgeClassName = hasSelection
    ? "bg-additional-orange text-orange"
    : "bg-orange text-white";

  return (
    <Badge
      className={`rounded-1 px-2 py-1 fs-14 fw-normal ${badgeClassName}`}
      style={{ height: "24px" }}
    >
      {t("Required")}
    </Badge>
  );
};

export default React.memo(RequiredChoiceBadge);
